import { Injectable } from '@angular/core';
import { EzoomApiProvider } from './ezoom-api';

@Injectable()
export class FieldsProvider {

    constructor(
        public api: EzoomApiProvider
    ) { }

    public getFields (sequency) {
        return new Promise((resolve, reject) => {
            this.api.get('fields', { sequency: sequency }).subscribe((response: any) => {
                if (response.status) {
                    resolve(response.data);
                } else {
                    reject(response.data);
                }
            });
        });
    }

    public getField (id, sequency) {
        return new Promise((resolve, reject) => {
            this.api.get('fields/details/' + id, { sequency: sequency }).subscribe((response: any) => {
                if (response.status) {
                    resolve(response.data);
                } else {
                    reject(response.data);
                }
            });
        });
    }

    public reserve (id: any, params: any = {}) {
        return new Promise((resolve, reject) => {
            this.api.post('fields/reserve/' + id, params).subscribe((response: any) => {
                if (response.status) {
                    resolve(response.data);
                } else {
                    reject(response.data);
                }
            });
        });
    }

    public getSchedule(id: number, day: string = null, testServiceReserve: boolean = false) {
        return new Promise((resolve, reject) => {
            let params: any = {};
            if (day)
                params.day = day;
            if (testServiceReserve)
                params.testServiceReserve = testServiceReserve;
            this.api.get('fields/schedule/' + id, params).subscribe((response: any) => {
                if (response.status) {
                    resolve(response.data);
                } else {
                    reject(response.data);
                }
            });
        });
    }

    public getFullyBookedDays (id: any) {
        return new Promise((resolve, reject) => {
            this.api.post('fields/get-fully-booked-days/' + id, {}).subscribe((response: any) => {
                if (response.status) {
                    resolve(response.data);
                } else {
                    reject(response.data);
                }
            });
        });
    }

}



// WEBPACK FOOTER //
// ./src/providers/fields.ts